(function () {
  'use strict';

  function map2Factory (apiFactory, Common, postalCodesFactory) {
    const factory = {};
    // TODO: uncomment this if we need to store the coordinates, otherwise, delete this
    // factory.bbox = {};

    // this is where you add sources for the map to utilize
    const sources = [
      {
        // this is for the postal codes
        name: 'postalcode-area-source',
        options: {
          type: 'vector',
          scheme: 'wmts',
          tiles: [
            web2print.env.tilesBaseUrl +
              'gwc/service/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&LAYER=pcc4:postalcode_area&STYLE=&TILEMATRIX=EPSG:900913:{z}&TILEMATRIXSET=EPSG:900913&FORMAT=application/x-protobuf;type=mapbox-vector&TILECOL={x}&TILEROW={y}',
          ],
        },
      },
      {
        name: 'postalcodegroup',
        options: {
          type: 'vector',
          scheme: 'tms',
          tiles: [
            web2print.env.tilesBaseUrl +
              'gwc/service/tms/1.0.0/pcc4:postalcodegroup@EPSG%3A900913@pbf/{z}/{x}/{y}.pbf',
          ],
        },
      },
      {
        // this is for the county names
        name: 'county-source',
        options: {
          type: 'vector',
          scheme: 'wmts',
          tiles: [
            web2print.env.tilesBaseUrl +
              'gwc/service/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&LAYER=pcc4:county&STYLE=&TILEMATRIX=EPSG:900913:{z}&TILEMATRIXSET=EPSG:900913&FORMAT=application/x-protobuf;type=mapbox-vector&TILECOL={x}&TILEROW={y}',
          ],
        },
      },
      {
        // this is for the municipality names
        name: 'municipality-source',
        options: {
          type: 'vector',
          scheme: 'wmts',
          tiles: [
            web2print.env.tilesBaseUrl +
              'gwc/service/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&LAYER=pcc4:municipality&STYLE=&TILEMATRIX=EPSG:900913:{z}&TILEMATRIXSET=EPSG:900913&FORMAT=application/x-protobuf;type=mapbox-vector&TILECOL={x}&TILEROW={y}',
          ],
        },
      },
    ];

    // this is where you add map layers
    // NOTE: should correspond to the sources
    const layers = [
      {
        // invisible layer, used for click function, this is the polygons/features
        id: 'zipcode-area',
        type: 'fill',
        source: 'postalcode-area-source',
        'source-layer': 'postalcode_area',
        paint: {
          'fill-color': 'transparent',
        },
        layout: {
          visibility: 'none',
        },
      },
      {
        // visible layer, this shows the border of the polygons
        id: 'zipcode-area-border',
        type: 'line',
        source: 'postalcode-area-source',
        'source-layer': 'postalcode_area',
        paint: {
          'line-color': '#00a0d6',
          'line-width': 1.5,
          'line-opacity': 0.5,
        },

        layout: {
          visibility: 'none',
        },
      },
      {
        // this layer is added when a feature(polygon) is clicked/selected, fills polygon with color
        id: 'zipcode-area-highlight',
        type: 'fill',
        source: 'postalcode-area-source',
        'source-layer': 'postalcode_area',
        paint: {
          'fill-color': '#FEEFAC',
          'fill-opacity': 0.9,
        },

        filter: ['in', 'postalcode', ''],
        layout: {
          visibility: 'visible',
        },
      },
      {
        // this layer highlights selected area with a border around it
        id: 'zipcode-area-highlight-border',
        type: 'line',
        source: 'postalcode-area-source',
        'source-layer': 'postalcode_area',
        paint: {
          'line-color': '#00a0d6',
          'line-width': 2,
        },
        filter: ['in', 'postalcode', ''],
        layout: {
          visibility: 'visible',
        },
      },
      {
        // this layer fills selected areas with the color yellow on hover (only works in handmode and not in selectionmode)
        id: 'zipcode-area-highlight-hover',
        type: 'fill',
        source: 'postalcode-area-source',
        'source-layer': 'postalcode_area',
        paint: {
          'fill-color': 'yellow',
          'fill-opacity': 0.3,
        },
        filter: ['in', 'postalcode', ''],
        layout: {
          visibility: 'visible',
        },
      },
      {
        // this layer is added when a feature(polygon) is clicked/selected, shows text on polygons
        id: 'zipcode-area-text',
        type: 'symbol',
        source: 'postalcode-area-source',
        'source-layer': 'postalcode_area',
        layout: {
          'symbol-placement': 'point',
          'text-font': ['Roboto Regular'],
          'text-field': '{postalcode}',
          'text-size': 12,
          visibility: 'none',
        },
        paint: {
          'text-color': '#077bb8',
          'text-opacity': 1,
        },
        minzoom: 6,
      },
      {
        // this is for the counties display
        id: 'county-text',
        type: 'symbol',
        source: 'county-source',
        'source-layer': 'county',
        layout: {
          'symbol-placement': 'point',
          'text-font': ['Roboto Regular'],
          'text-field': '{name}',
          'text-size': 12,
          visibility: 'visible',
        },
        paint: {
          'text-color': '#87919b',
          'text-opacity': 1,
        },
        minzoom: 1,
      },
      {
        // this is for the municipalities display
        id: 'municipality-text',
        type: 'symbol',
        source: 'municipality-source',
        'source-layer': 'municipality',
        layout: {
          'symbol-placement': 'point',
          'text-font': ['Roboto Regular'],
          'text-field': '{name}',
          'text-size': 12,
          visibility: 'visible',
        },
        paint: {
          'text-color': '#9eb1bb',
          'text-opacity': 1,
        },
        minzoom: 8,
      },
    ];

    // separate array of layers for postal code group
    // so that ADR wont have useless layers loaded.
    const postalCodeGroupLayers = [
      {
        // invisible layer, used for click function, this is the polygons/features
        id: 'postalcodegroup-area-bg',
        type: 'fill',
        source: 'postalcodegroup',
        'source-layer': 'postalcodegroup',
        paint: {
          'fill-color': '#108B33',
          'fill-opacity': 0.15,
        },
        layout: {
          visibility: 'visible',
        },
      },
      {
        // invisible layer, used for click function, this is the polygons/features
        id: 'postalcodegroup-area',
        type: 'fill',
        source: 'postalcodegroup',
        'source-layer': 'postalcodegroup',
        paint: {
          'fill-color': 'transparent',
        },
        layout: {
          visibility: 'visible',
        },
      },
      {
        id: 'postalcodegroup_border_zoom',
        type: 'line',
        source: 'postalcodegroup',
        'source-layer': 'postalcodegroup',
        paint: {
          'line-color': 'white',
          'line-width': 5,
          'line-opacity': 0.6,
        },

        layout: {
          visibility: 'visible',
        },

        minzoom: 6,
      },
      {
        id: 'postalcodegroup_border',
        type: 'line',
        source: 'postalcodegroup',
        'source-layer': 'postalcodegroup',
        paint: {
          'line-color': 'white',
          'line-width': 2,
        },

        layout: {
          visibility: 'visible',
        },

        maxzoom: 6,
      },
      {
        //   'id': 'postalcodegroup-text',
        //   'type': 'symbol',
        //   'source': 'postalcodegroup',
        //   'source-layer': 'postalcodegroup',
        //   'layout': {
        //     'symbol-placement': 'point',
        //     'text-font': ['Roboto Regular'],
        //     'text-field': '{code}',
        //     'text-size': 12,
        //     'visibility': 'visible'
        //   },
        //   'paint': {
        //     'text-color': '#000',
        //     'text-opacity': 1
        //   },
        //   'minzoom': 4
        // }, {
        id: 'postalcodegroup-name-text',
        type: 'symbol',
        source: 'postalcodegroup',
        'source-layer': 'postalcodegroup',
        layout: {
          'symbol-placement': 'point',
          'text-font': ['Roboto Regular'],
          'text-field': '{name}',
          'text-size': 12,
          visibility: 'visible',
        },
        paint: {
          'text-color': '#000',
          'text-opacity': 1,
        },
        minzoom: 4,
      },
    ];

    function addPostalCodeGroupLayers () {
      factory.layers = layers.concat(postalCodeGroupLayers);
    }

    function getBaseMap () {
      return apiFactory.getBaseMap.get().$promise;
    }

    function fetchAllBbox (params) {
      return apiFactory.fetchAllBbox.post(params).$promise;
    }

    function getAllBbox (cb) {
      const params = {
        postalcodes: postalCodesFactory.zipcodes.join(','),
      };

      fetchAllBbox(params)
        .then((res) => {
          cb(res.bbox);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    function collectCoordinates (res, cb) {
      // NOTE: the commented codes is for a case where we need to store the coordinates in the front end
      // Right now, we're waiting for updates from sweco for the endpoint for getting bbox based on zipcodes
      // TODO: uncomment codes if we need to store the coordinates, otherwise, delete them

      const coordinates = [];
      (res || []).forEach((item) => {
        // factory.bbox[item.postalcode] = item.bbox;
        coordinates.push(item.bbox || item);
      });

      // Common.set('mapCoordinates', factory.coordinates);
      cb(coordinates);
    }

    function setToADRLayers () {
      factory.layers = layers;
    }

    factory.getBaseMap = getBaseMap;
    factory.sources = sources;
    factory.collectCoordinates = collectCoordinates;
    factory.getAllBbox = getAllBbox;
    factory.addPostalCodeGroupLayers = addPostalCodeGroupLayers;
    factory.setToADRLayers = setToADRLayers;

    return factory;
  }

  angular.module('web2print.recipients').factory('map2Factory', map2Factory);
})();
